// The timezones a booking calendar can be in.
//
// ⚠️ Deliberately a SHORT FIXED LIST rather than every IANA zone: these are the
// zones the agency's clients are actually in, and a searchable list of 400 would
// make the common case worse to serve an edge case that does not exist yet.
// Adding one is a line here. Same reasoning — and the same list — as the lead
// bot's business-hours editor.
//
// ⚠️ IANA NAMES, NEVER OFFSETS. Brisbane and Sydney are the same clock for half
// the year and an hour apart for the other half; Auckland moves too, in the
// opposite calendar direction from the northern hemisphere. The name carries the
// transition table, a "+10" does not.
export const BOOKING_TIMEZONES = [
  { value: 'Australia/Brisbane', label: 'Brisbane (QLD — no daylight saving)' },
  { value: 'Australia/Sydney', label: 'Sydney / Melbourne / Canberra / Hobart' },
  { value: 'Australia/Adelaide', label: 'Adelaide (SA)' },
  { value: 'Australia/Darwin', label: 'Darwin (NT — no daylight saving)' },
  { value: 'Australia/Perth', label: 'Perth (WA — no daylight saving)' },
  { value: 'Pacific/Auckland', label: 'Auckland (NZ)' },
];

export const DEFAULT_BOOKING_TIMEZONE = 'Australia/Brisbane';
